const ja_wyrmprints = {
  400001: '勇躍の指輪',
  400002: 'シーフードスープ',
  400003: 'ドラゴンの秘薬',
  400004: 'マナスポット',
  400005: '古びたハープ',
  400006: '名馬スカービット',
  400007: '聖光輪',
  400008: 'ティータイム',
  400009: 'バラドンナの花',
  400010: 'アルベリア国旗',
  400011: '破天の角笛',
  400012: '頂に吼える牙',
  400013: '《結社》の仮面',
  400014: '遥かなる霊峰',
  400015: '森と湖の歌声',
  400016: 'ドラゴンの寝床',
  400017: '秘伝の書',
  400018: '鉄騎兵の盾',
  400019: 'セントロータスの風	',
  400020: 'アロマポット',
  400021: '八つ葉のクローバー',
  400022: '禁じられた遺物',
  400023: 'つわものたちの夢の跡',
  400024: '『グリモルス・デクス』写本',
  400025: '闇夜の通告',
  400026: '明日への轍',
  400027: 'ヴィオ・ライジエ・アルベリア！',
  400028: '聖草ポーションハーブ',
  400029: '過ぎ去りし日の王冠',
  400030: '',
  400031: '溶けない氷',
  400032: 'パンプキンボックス',
  400033: '百刃繚乱',
  400034: '運命の救済',
  400035: 'セクシー・スナイパー',
  400036: '雨空の思い出',
  400037: 'アツアツ女子会',
  400038: '我らが知恵袋',
  400039: 'サバイバルデイズ',
  400040: '天空の覇者',
  400041: '王の威厳',
  400042: '未知への一歩',
  400043: '手がかかるんだから！',
  400044: 'ここは退却しましょう！',
  400045: 'この身は影となりて',
  400046: '楽しき命懸けの戦',
  400047: '甲冑師の大望',
  400048: '研究成果の新魔術	',
  400049: '鍛冶屋三姉妹の絆',
  400050: 'ダンス・ダンス・バトル！',
  400051: '戦場のふたり',
  400052: 'ケガは私が治します',
  400053: '聖騎士の守り',
  400054: '強い男になるために',
  400055: '五竜の咆哮：ミドガルズオルム',
  400056: '五竜の咆哮：マーキュリー',
  400057: '五竜の咆哮：ブリュンヒルデ',
  400058: '五竜の咆哮：ユピテル	',
  400059: '五竜の咆哮：ゾディアーク',
  400060: 'デンジャラスビューティ',
  400061: 'シルキーのお手伝い',
  400062: 'ブレイジング・クラウン',
  400063: '天才の閃き',
  400064: 'ゴージャス・パーティー',
  400065: '好敵手',
  400066: '聖なる祈り',
  400067: 'ドラゴンの血族',
  400068: 'リュカのイタズラ',
  400069: '在りし日の幸せ',
  400070: 'レヴィオンの英雄',
  400071: 'ハンティングナイト',
  400072: 'テンペストグローリー',
  400073: '理想のもとに集いし者たち',
  400074: 'クラウの策略',
  400075: '鬼教官のエール',
  400076: 'クリスタリアの少女',
  400077: 'ハロウィン・ウィッチ・クラフト',
  400078: 'トリック・トリート・トリック',
  400079: '',
  400080: '戦旗の乙女',
  400081: '',
  400082: '',
  400083: '悠久の時を経て',
  400084: '古の盟約',
  400085: '美の秘訣',
  400086: '',
  400087: 'スイーツパイレーツ',
  400088: '',
  400089: '',
  400090: '地道な活動',
  400091: '星竜樹に願いを',
  400092: 'チョコレート・レッスン',
  400093: '旅のエスコート',
  400094: '',
  400095: 'アルクトスの猛特訓！',
  400096: '花嫁はドラゴン',
  400097: 'ふたりの絆',
  400098: '真夏の聖騎士',
  400099: '宝石と剣',
  400100: 'サムライたちの休息	',
  400101: 'お出かけの日のとっておき',
  400102: '鮮烈なコンビネーション',
  400103: '風のぬくもり',
  400104: '美しき烈風',
  400105: '見慣れぬ目線',
  400106: 'ガルーダの羽根',
  400107: 'ルイーゼの趣味',
  400108: '蒼海の女王',
  400109: '',
  400110: '響き渡る歌声',
  400111: '聖職者の休日',
  400112: 'ある日の陽だまり',
  400113: 'ないしょの友達',
  400114: '雪降る街で',
  400115: '星竜祭の王子様',
  400116: '子供たちの星竜祭',
  400117: '星降る夜の晩餐',
  400118: '星竜祭のスペシャルケーキ',
  400119: '極上のおもてなし',
  400120: '',
  400121: 'ヴォルカニッククイーン',
  400122: '',
  400123: 'あなたへのプレゼント',
  400124: '謹賀新年',
  400125: 'ヒノモトよりの使者',
  400126: '羽子板勝負！',
  400127: '新年最初の運試し',
  400128: 'ドラゴンサーカス',
  400129: 'ベストパフォーマンス',
  400130: '輝ける場所',
  400131: 'ワンダフルトリック',
  400132: '',
  400133: '',
  400134: '',
  400135: 'トゥインクルナイトウィッチーズ',
  400136: '春節のお祭り',
  400137: '仙花焔',
  400138: 'ドラゴンダンス',
  400139: '薔薇の貴公子',
  400140: '炎の饗宴',
  400141: '最愛の人へ',
  400142: 'ローズフェアリー',
  400143: 'ラッピングフィール',
  400144: '漢のバレンタイン',
  400145: 'トキメキデートスタイル',
  400146: 'エレガントエスコート',
  400147: 'ギヴ・ミー・ユアハンド',
  400148: 'オネストモーメント',
  400149: '',
  400150: '闇の光条',
  400151: 'ダビアの湿地帯',
  400152: '可憐な舞姫',
  400153: '真実の探求者',
  400154: '儚げな少女',
  400155: '',
  400156: '異端の研究室',
  400157: '読書は苦手？',
  400158: '万雷の王',
  400159: '',
  400160: '',
  400161: '',
  400162: '',
  400163: '功夫の道',
  400164: '',
  400165: '',
  400166: '',
  400167: 'シャイニング・オーバーロード',
  400168: '夢に見た学校生活♪	',
  400169: '',
  400170: '',
  400171: '師匠の一喝',
  400172: '森が紡ぐ絆',
  400173: '',
  400174: 'エッグに描く夢',
  400175: 'タイニー・ドラゴンパピエ',
  400176: '母の愛',
  400177: '',
  400178: '',
  400179: '',
  400180: '',
  400181: '',
  400182: '',
  400183: '',
  400184: '',
  400185: '',
  400186: '',
  400187: '',
  400188: '',
  400189: '',
  400190: '',
  400191: '',
  400192: '',
  400193: '',
  400194: '',
  400195: '',
  400196: '',
  400197: '',
  400198: '',
  400199: '',
  400200: '',
  400201: '',
  400202: '',
  400203: '',
  400204: '',
  400205: '',
  400206: '',
  400207: '',
  400208: '',
  400209: '',
  400210: '',
  400211: '',
  400212: '',
  400213: '',
  400214: '',
  400215: '',
  400216: '',
  400217: '',
  400218: '',
  400219: '',
  400220: '',
  400221: '',
  400222: '',
  400223: '',
  400224: '',
  400225: '',
  400226: '',
  400227: '',
  400228: '',
  400229: '',
  400230: '',
  400231: '',
  400232: '',
  400233: '',
  400234: '',
  400235: '',
  400236: '',
  400237: '',
  400238: '',
  400239: '',
  400240: '',
  400241: '',
  400242: '',
  400243: '三姉妹の日常',
  400244: '',
  400245: 'ドラゴンの鍛冶屋さん',
  400246: '',
  400247: '',
  400248: '',
  400249: '',
  400250: '',
  400251: '',
  400252: '',
  400253: '',
  400254: '',
  400255: '',
  400256: '',
  400257: '',
  400258: '',
  400259: '',
  400260: '',
  400261: '',
  400262: '',
  400263: '',
  400264: '',
  400265: '',
  400266: '',
  400267: '',
  400268: '',
  400269: '',
  400270: '',
  400271: '',
  400272: '',
  400273: '',
  400274: '',
  400275: '',
  400276: '',
  400277: '英雄、来たれり',
  400278: '',
  400279: '特務機関の伝書ふくろう',
  400280: '時空を超える友情	',
  400281: '',
  400282: '聖城の花婿たち',
  400283: '',
  400284: '',
  400285: 'シェフと共に朝食を',
  400286: 'ミツバの手ほどき',
  400287: '',
  400288: '愛すべき森の住人',
  400289: '',
  400290: '',
  400291: '',
  400292: '',
  400293: 'つかの間のやすらぎ',
  400294: '',
  400295: '',
  400296: '',
  400297: '',
  400298: '',
  400299: '',
  400300: '',
  400301: '',
  400302: '',
  400303: '',
  400304: '',
  400305: '',
  400306: '',
  400307: '',
  400308: '',
  400309: '',
  400310: '',
  400311: '',
  400312: '',
  400313: '',
  400314: '',
  400315: '',
  400316: '',
  400317: '',
  400318: '',
  400319: '',
  400320: '',
  400321: '',
  400322: '',
  400323: '',
  400324: '',
  400325: '',
  400326: '',
  400327: '',
  400328: '',
  400329: '',
  400330: '',
  400331: '',
  400332: '',
  400333: '',
  400334: '忘れられない夏',
  400335: '太鼓を打ち鳴らせ！',
  400336: '渚のビーチフラッグ',
  400337: '説教師のバカンス',
  400338: 'シーサイド・プリンセス',
  400339: '海の家のにぎわい',
  400340: '波乗り兄妹',
  400341: '',
  400342: '',
  400343: '',
  400344: '',
  400345: '',
  400346: '',
  400347: '',
  400348: '',
  400349: '',
  400350: '',
  400351: '',
  400352: '',
  400353: '',
  400354: '',
  400355: '',
  400356: '',
  400357: '',
  400358: '',
  400359: '',
  400360: '',
  400361: '',
  400362: '',
  400363: '',
  400364: '',
  400365: '',
  400366: '',
  400367: '',
  400368: '',
  400369: '',
  400370: '',
  400371: '',
  400372: '',
  400373: '',
  400374: '',
  400375: '',
  400376: '',
  400377: '',
  400378: '',
  400379: '吹き荒れる暴風',
  400380: '我ら、キャッスル応援団！',
  400381: '幽美なる虚無',
  400382: 'ダークネスルーラー',
  400383: '',
  400384: 'エンドレスワルツ',
  400385: '白燕騎士団のデコボココンビ',
  400386: '',
  400387: '妖艶なる宮廷魔術師	',
  400388: 'マスカレード・オペラ',
  400389: '遙かなる主へ',
  400390: '彼方より来たりて',
  400391: 'あたしだけのリュカきゅん☆☆☆',
  400392: 'おらぁ！チャリオッツで来たぜぇ！',
  400393: 'プレゼント・フォーユー',
  400394: 'キラメキ☆スパークルナイト',
  400395: '天に吠ゆる夜狼',
  400396: 'もふもふわんだーらんど',
  400397: '共鳴する勇気',
  400398: 'Dr.ワイリーの刺客たち・Ｂ＆Ｗ',
  400399: 'Dr.ワイリーの刺客たち・Ａ＆Ｃ',
  400400: 'Dr.ワイリーの刺客たち・Ｍ＆Ｑ',
  400401: 'Dr.ワイリーの刺客たち・Ｆ＆Ｈ',
  400402: '',
  400403: '',
  400404: '',
  400405: '',
  400406: '猫猪戯画',
  400407: '十二竜氏がふたり、参る！',
  400408: '新しい年のはじまり',
  400409: '過日のメモリア',
  400410: '病ヲもたらスもの',
  400411: '終わらない世界で',
  400412: 'ロックンロールトリップ',
  400413: 'アンビバレント・フレア',
  400414: 'メイド部隊におまかせ！',
  400415: '天空の王者',
  400416: '漆黒、纏いて挑む',
  400417: 'アイルーのおもてなし',
  400418: '森の奥に潜むもの',
  400419: '聖城に舞い込む依頼',
  400420: '',
  400421: '',
  400422: '',
  400423: '',
  400424: 'STRANGELAND',
  400425: '',
  400426: '',
  400427: '',
  400428: '',
  400429: '',
  400430: '',
  400431: '開春はなやぐ空の華'
}

export default ja_wyrmprints